import * as React from 'react';
import { ClockArrowUpIcon } from 'lucide-react';
import type {
  InvoiceIndicators,
  IndicatorStatusCode,
} from 'contracts/tracking-v2/invoice-indicators';

import { IndicatorCard as Card } from './indicator-card-toolkit';
import { getPercentage } from './utils';

type Props = {
  indicator?: InvoiceIndicators['preparingForTransit']
  onToggleStatus: (status: IndicatorStatusCode) => void;
  activeStatus?: string | IndicatorStatusCode;
  loading?: boolean;
}

export const PreparingForTransitCard = ({
                                          indicator,
                                          onToggleStatus,
                                          activeStatus,
                                          loading,
                                        }: Props) => {
  return (
    <Card.Root loading={loading}>
      <Card.Header
        title={'Aguardando saída'}
        icon={<ClockArrowUpIcon className={'stroke-slate-800'} />}
      />
      <Card.Body>
        <Card.BodyHeadLine
          count={indicator?.count}
          percentage={indicator?.percentage}
        />
        <Card.BodyBottomLine>
          <Card.ActionButton
            onClick={() => onToggleStatus('preparingForTransitWithinDeadline')}
            active={activeStatus === 'preparingForTransitWithinDeadline'}
            tooltip={indicator?.withinDeadline.count}
          >
            {getPercentage(indicator?.withinDeadline.percentage)}% no prazo
          </Card.ActionButton>
          <Card.ActionButton
            onClick={() => onToggleStatus('preparingForTransitOverDeadline')}
            active={activeStatus === 'preparingForTransitOverDeadline'}
            tooltip={indicator?.overDeadline.count}
          >
            {getPercentage(indicator?.overDeadline.percentage)}% com atraso
          </Card.ActionButton>
          <Card.ActionButton
            onClick={() => onToggleStatus('preparingForTransitWithoutDeadline')}
            active={activeStatus === 'preparingForTransitWithoutDeadline'}
            tooltip={indicator?.withoutDeadline.count}
          >
            {getPercentage(indicator?.withoutDeadline.percentage)}% sem prazo
          </Card.ActionButton>
        </Card.BodyBottomLine>
      </Card.Body>
    </Card.Root>
  );
};